import React, { PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  title: string;
  value: Array<any>;
}>;

export default function ResWidget({ title, value }: Props) {
  return (
    <div className="w-24 py-1 px-2 rounded-md bg-stone-800">
      <div className="text-center text-white text-xs">{title}</div>
      {value.map((v: string, i: number) => (
        <div key={i} className="text-center text-cyan-300">
          {v}
        </div>
      ))}
    </div>
  );
}
